module.exports = __webpack_public_path__ + "img/hero.581fe343.png";